// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3zqpH","signatureBlock":"Footer_signatureBlock__3s1TA","signature":"Footer_signature__1ABN6"};